/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

import { BrowserRouter } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ConfigProvider } from 'antd';

import StorageService from '../../services/StorageService';
import AuthRouting from './AuthRoutin';
import MainRouting from './MainRouting';

import SessionService from '../../services/SessionService';
import './style.scss';

const AppRouting = () => {
  const advisor = useSelector((state) => state.userReducer.advisor);
  const [isAuthenticated, setAuthenticated] = useState(
    StorageService.getJWTToken('acc') ||
    SessionService.getJWTToken('acc')
  );
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  const storedTheme = localStorage.getItem('theme');
  const [theme, setTheme] = useState(storedTheme);
  

  useEffect(() => {
    if(advisor?.preferred_theme || storedTheme) {
      const currentTheme = advisor?.preferred_theme 
        ? advisor?.preferred_theme
        : storedTheme;
      localStorage.setItem('theme', currentTheme);
      setTheme(currentTheme);
    } else {
      setTheme('dark-theme');
    }
  }, [advisor]);

  useEffect(() => {
    if(advisor?.preferred_theme === 'system') {
      const darkModeMediaQuery = window.matchMedia('(prefers-color-scheme: dark)');

      const handleChange = (event) => {
        const newTheme = event.matches ? 'dark' : 'light';
        document.body.className = newTheme === 'dark' ? 'dark-theme' : 'light-theme';
        localStorage.setItem('theme', theme);
      };
  
      darkModeMediaQuery.addEventListener('change', handleChange);

      return () => {
        darkModeMediaQuery.removeEventListener('change', handleChange);
      };
    }
  }, [advisor?.preferred_theme]);

  useEffect(() => {
    if(theme) {
      const userTheme = theme !== 'system'
        ? theme 
        : !prefersDark
          ? 'light-theme'
          : 'dark-theme';
      document.body.className = userTheme;
      localStorage.setItem('theme', userTheme);
    }
  }, [theme]);

  useEffect(() => {
    const token = StorageService.getJWTToken('acc') || SessionService.getJWTToken('acc');
    if (token) {
      setAuthenticated(token);
    } else {
      setAuthenticated('');
    }
  }, [advisor]);

  return (
    <BrowserRouter>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: '#FB7B34',
            colorPrimaryBorder: '#0F0F0F',
            colorBgContainerDisabled: '#FAE5D8'
          },
          components: {
            Layout: {
              headerBg: '#ffffff',
              headerColor: '#3C4043',
              headerHeight: 72,
              siderBg: '#FFFFFF',
              bodyBg: '#F6F7F9',
            },
            Menu: {
              collapsedIconSize: 0,
              darkItemBg: 'transparent',
              darkSubMenuItemBg: 'transparent',
              darkItemColor: '#7E716D',
              // itemSelectedBg: '#FD833A',
              // itemActiveBg: '#F6F7F9',
              itemHeight: 48,
              itemMarginBlock: 8,
            },
            Switch: {
              handleBg: '#0F0F0F',
              trackHeight: 22,
              trackPadding: 1
            },
            Form: {
              labelColor: '#0F0F0F',
              labelFontSize: 14,
              itemMarginBottom: 20
            },
            Progress: {
              defaultColor: '#FB7B34',

            },
            Slider: {
              railSize: 10,
              handleSize: 20,
              handleSizeHover: 20,
              handleColor: '#FB7B34',
            },
            Collapse: {
              headerPadding: '12px 0',
              contentPadding: '0'
            },
          },
        }}
      >
        {isAuthenticated ? <MainRouting theme={theme}/> : <AuthRouting theme={theme} setTheme={setTheme}/>}
      </ConfigProvider>
    </BrowserRouter>
  );
};

export default AppRouting;
